<template>
  <img
    :src="
      gender == 2
        ? `${BaseUrl}assets/common/gender_woman_l.png`
        : gender == 1
        ? `${BaseUrl}assets/common/gender_man_l.png`
        : `${BaseUrl}assets/common/gender_unknow_l.png`
    "
    :srcset="
      gender == 2
        ? `${BaseUrl}assets/common/gender_woman_l@2x.png`
        : gender == 1
        ? `${BaseUrl}assets/common/gender_man_l@2x.png`
        : `${BaseUrl}assets/common/gender_unknow_l@2x.png`
    "
    :width="size"
    :height="height ? height :''"
    class="avatar"
  />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Avatar",
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  props: {
    gender: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 60,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
};
</script>
